import { render } from "./Step4.vue?vue&type=template&id=cf5139fc&scoped=true"
import script from "./Step4.vue?vue&type=script&lang=js"
export * from "./Step4.vue?vue&type=script&lang=js"

import "./Step4.vue?vue&type=style&index=0&id=cf5139fc&scoped=true&lang=css"

import exportComponent from "/data03/virt76591/domeenid/www.kuulsaal.ee/bookings-frontend/git/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf5139fc"]])

export default __exports__